import { download } from '@/utils';
import { IGridServerSideDatasource, IServerSideGetRowsParams, toQuery } from '@samc/centricity-core';
import { AjaxHelper, IPaginatedList, errToMessage, getToken } from '@samc/common';
import { IDealListResponse } from '../Interfaces';

export class ExitDealFastDataSource implements IGridServerSideDatasource {

    public get fullCount(): number { return this._fullCount ?? 0; }

    public pageSize: number = 50;
    public cacheSize: number = 10;
    public adhocFilter: string = '';
    private _fullCount: number = 0;
    private _queryParams: any;
    private _onGetRows?: (rows: IDealListResponse[], fullCount: number) => void | undefined;

    public constructor(
        private _statusName: string | null,
        private _eligibleLoanIds?: number[] | null,
        onGetRows?: (rows: IDealListResponse[], fullCount: number) => void | undefined,
        private _verificationToken: string | null = null
    ) {
        this._queryParams = {};

        if (onGetRows !== undefined) {
            this._onGetRows = onGetRows;
        }
    }

    public setOnGetRowsHandler(handler: (rows: IDealListResponse[], fullCount: number) => void | undefined) {
        this._onGetRows = handler;
    }

    public async getRows(params: IServerSideGetRowsParams) {
        try {
            let helper;
            if (this._eligibleLoanIds === null || this._eligibleLoanIds === undefined) {
              helper = new AjaxHelper('/griddatasource/exitdeals/fastlist', this._verificationToken, null, getToken());
            } else {
              helper = new AjaxHelper('/griddatasource/exitdeals', this._verificationToken, null, getToken());
            }
            this._queryParams = toQuery(params);

            // @ts-ignore
            const statusFilter = params?.request?.filterModel?.status?.filter;
            // status filter should only override the base filter if it is among the statuses in the base filter
            if (statusFilter !== undefined && (this._statusName === null || this._statusName.includes(statusFilter))) {
                this._queryParams.status = statusFilter;
            } else if (this._statusName !== null) {
                this._queryParams.status = this._statusName;
            }

            const result = this._eligibleLoanIds === null || this._eligibleLoanIds === undefined
                ? await helper.getData<IPaginatedList<IDealListResponse>>('', this._queryParams)
                : await helper.postData<IPaginatedList<IDealListResponse>>('', { loanIds: this._eligibleLoanIds }, this._queryParams);

            this._fullCount = result.fullCount;
            params.success({ rowData: result.items, rowCount: result.fullCount });

            if (this._onGetRows !== undefined) {
                this._onGetRows(result.items, result.fullCount);
            }
        } catch (err: any) {
            params.fail();
        }
    }

    public async exportAllAsExcel() {
        try {
            if (this._fullCount > 0) {
                const helper = new AjaxHelper('/TransactionManagement/Deals/', this._verificationToken, null, getToken());
                this._queryParams.handler = 'ExportExcel';
                window.loading?.('Downloading excel...');

                const data = await helper.getData<Blob>('', this._queryParams, { responseType: 'blob' });
                download(data, 'Deals.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            }
        } catch (err) {
            window.showAlert?.({
                type: 'error',
                title: 'Failed to download excel',
                description: 'For more detailed information, please contact support team.',
                errors: errToMessage(err),
                closingOption: 'holdOpen'
            });
        } finally {
            window.loading?.();
        }
    }

}